import React, { useState } from "react";
import { Modal, ModalBody, ModalContent } from "@chakra-ui/react";
import { FaArrowLeft, FaSpinner, FaTimes } from "react-icons/fa";
import SelectLocation from "../Upload/SelectLocationModal";

function LocationModal({ isOpen, previous, setShowModal, onClose }) {
  const [currentLocation, setCurrentLocation] = useState({
    longitude: null,
    latitude: null,
  });

  const [loading] = useState(false);

  return (
    <Modal
      size={"lg"}
      isOpen={isOpen}
      onClose={() => onClose()}
      className="rounded-2xl w-full"
    >
      <ModalContent
        className=" w-full py-[22px] h-[546px]"
        containerProps={{ justifyContent: "center", alignItems: "center" }}
        borderRadius={20}
      >
        <div className="flex   px-[20px] relative items-center w-full">
          {previous ? (
            <div
              onClick={onClose}
              className="w-[36px] absolute cursor-pointer  h-[36px] float-left bg-[#ffffff] border-[.1px] rounded-full my-[1rem]  justify-center flex items-center"
            >
              <FaArrowLeft size={12} className="float-left text-[#050558]" />
            </div>
          ) : (
            <div
              onClick={onClose}
              className="w-[36px] absolute cursor-pointer  h-[36px] float-left bg-[#ffffff] border-[.1px] rounded-full my-[rem]  justify-center flex items-center"
            >
              <FaTimes size={12} className="float-left text-[#050558]" />
            </div>
          )}
          <h4 className="text-center mx-auto text-black font-[500] text-[14px]">
            Select Location
          </h4>
        </div>
        <ModalBody className="my-[16px]  w-full">
          {loading ? (
            <FaSpinner className="text-center mx-auto" />
          ) : (
            <SelectLocation
              setCurrentLocation={setCurrentLocation}
              close={onClose}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default LocationModal;
